<div class="wrapper">
  <app-dropdown
    (checkForErrors)="checkForErrors($event)"
    [enableMultiple]="false"
    [enableSearch]="true"
    [error]="errorMessages['activityCodes']"
    [options]="filteredActivityCodesSegmentOptions"
    [parentFormGroup]="form"
    class="mb-[20px]"
    controlName="activityCodesSegment"
    label="Segment"
    placeholder="Select"
    />
  <app-dropdown
    (checkForErrors)="checkForErrors($event)"
    [enableMultiple]="false"
    [enableSearch]="true"
    [error]="errorMessages['activityCodes']"
    [options]="filteredActivityCodesLocationOptions"
    [parentFormGroup]="form"
    class="mb-[20px]"
    controlName="activityCodesLocation"
    label="Location"
    placeholder="Select"
    />
  <app-dropdown
    (checkForErrors)="checkForErrors($event)"
    [enableMultiple]="true"
    [enableSearch]="true"
    [error]="errorMessages['activityCodes']"
    [options]="filteredActivityCodeOptions"
    [parentFormGroup]="form"
    [selectionString]="'activity ids'"
    [showCount]="true"
    class="mb-[20px]"
    controlName="activityCodes"
    label="Activity IDs"
    placeholder="Select"
    />

  <div class="selected-activity-list flex flex-col justify-center mb-[40px]">
    @if (selectedActivitiesIds.length) {
      @for (activityId of selectedActivitiesIds; track activityId) {
        <div
          class="activity-id-name-container mb-[10px]">
          <div class="activity-id-name text-type-11">
            {{ activityId?.activity_id }} - {{ activityId?.name }}
          </div>
        </div>
      }
    } @else {
      <div class="activity-id-name-container">
        <div
          class="activity-id-name text-type-11">
          No activity ids selected
        </div>
      </div>
    }
  </div>

  <div
    class="station-range-section mb-[40px]"
    >
    <div class="station-range-section-label">Station Range:</div>
    @if ((
      stationRange?.from?.station
      || stationRange?.from?.offset_type
      || stationRange?.from?.offset_distance
      || stationRange?.to?.station
      || stationRange?.to?.offset_type
      || stationRange?.to?.offset_distance
      || alignment)) {
      <div
        (click)="openStationRangeDetails()"
        [class.station-range-details]="checkStationFormData()"
        class="station-range flex flex-col flex-wrap justify-start items-center space-y-[20px]"
        >
        @if (alignment) {
          <div
            class="alignment w-full">
            <div class="station-range-sub-section-label text-type-15">Alignment:</div>
            <div class="from-details text-type-11">
              {{ alignment }}
            </div>
          </div>
        }
        @if (stationRange?.from?.station
          || stationRange?.from?.offsetType
          || stationRange?.from?.offsetDistance) {
          <div
            class="from w-full">
            <div class="station-range-sub-section-label text-type-15">From:</div>
            <div class="from-details text-type-11">
              {{ stationRange?.from?.station }}
              @if (stationRange?.from?.offsetType) {
                <span
                  >
                  , {{ stationRange?.from?.offsetType }}
                </span>
              }
              @if (stationRange?.from?.offsetDistance) {
                <span
                  >
                  , {{ stationRange?.from?.offsetDistance }}
                </span>
              }
            </div>
          </div>
        }
        @if (stationRange?.to?.station
          || stationRange?.to?.offsetType
          || stationRange?.to?.offsetDistance) {
          <div
            class="to w-full">
            <div class="station-range-sub-section-label text-type-15">To:</div>
            <div class="to-details text-type-11">
              {{ stationRange?.to?.station }}
              @if (stationRange?.to?.offsetType) {
                <span
                  >
                  , {{ stationRange?.to?.offsetType }}
                </span>
              }
              @if (stationRange?.to?.offsetDistance) {
                <span
                  >
                  , {{ stationRange?.to?.offsetDistance }}
                </span>
              }
            </div>
          </div>
        }
      </div>
    } @else if (editable) {
      <div
        (click)="openStationRangeDetails()"
        class="station-range flex flex-row flex-wrap justify-start items-center"
        >
        <mat-icon class="add-icon mr-[8px]" svgIcon="plus" />
        Add Station Range
      </div>
    }
  </div>

  @if (displayCommentSection) {
    <div
      class="comment-section"
      >
      <app-text-area
        [parentFormGroup]="form"
        controlName="comment"
        label="COMMENT"
        />
    </div>
  }

  @if (mediaFiles?.length) {
    <app-pictures-section
      (onDelete)="deletePicture($event)"
      [isEditable]="editable"
      [pictures]="mediaFiles"
      class="pictures-section mb-[40px]"
      />
  }

  @if (showLocationSection()) {
    <app-location-station-card
      (onDelete)="deleteLocation()"
      [isEditable]="editable"
      [latitude]="form?.controls?.latitude?.value"
      [longitude]="form?.controls?.longitude?.value"
      [form]="form"
      [recordLabel]="'activity code'"
      class="location-section mb-[40px]"
      />
  }
</div>
